import { render, staticRenderFns } from "./GiftPoints.vue?vue&type=template&id=04e398ff&"
import script from "./GiftPoints.vue?vue&type=script&lang=js&"
export * from "./GiftPoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/branch.goz.fun/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04e398ff')) {
      api.createRecord('04e398ff', component.options)
    } else {
      api.reload('04e398ff', component.options)
    }
    module.hot.accept("./GiftPoints.vue?vue&type=template&id=04e398ff&", function () {
      api.rerender('04e398ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Views/GiftPoints.vue"
export default component.exports